import Axios from "axios";
import { REACT_APP_API_SIM } from "../../config";
import { HomeRouterOrder } from "../../types";

/**
 * Place a Home Router subscription order.
 *
 * POST /api/v2/HomeRouter/PlaceHomeRouterOrder (sim API), Bearer-authenticated
 * from the `tygo_user` token in localStorage.
 */
export type PlaceHomeRouterOrderPayload = {
  planName: string;
  providerId: number;
  totalAmount: number;
  customer: {
    idType: string;
    nationalId: string;
    fullName: string;
    email: string;
    contactNumber: string;
    alternativeContactNumber: string;
    city: string;
  };
};

const placeHomeRouterOrder = async (
  payload: PlaceHomeRouterOrderPayload,
  lang: string
) => {
  const user = JSON.parse(localStorage.getItem("tygo_user") || "{}");

  const response = await Axios.post(
    REACT_APP_API_SIM + "/api/v2/HomeRouter/PlaceHomeRouterOrder",
    payload,
    {
      headers: {
        accept: "text/plain; ver=2.0",
        "Content-Type": "application/json; ver=2.0",
        "Accept-Language": lang,
        authorization: "Bearer " + user.token,
      },
    }
  );

  return response.data;
};

/**
 * Fetch the Home Router subscription orders for the logged-in user.
 *
 * GET /api/v2/HomeRouter/GetMyHomeRoutersOrders (sim API), Bearer-authenticated.
 * The endpoint wraps the list in `returnData`, so we unwrap it here.
 */
const getHomeRouterOrders = async (lang: string): Promise<HomeRouterOrder[] | null> => {
  const user = JSON.parse(localStorage.getItem("tygo_user") || "{}");
  if (!user || !user.token) {
    return null;
  }

  const response = await Axios.get(
    REACT_APP_API_SIM + "/api/v2/HomeRouter/GetMyHomeRoutersOrders",
    {
      headers: {
        accept: "text/plain; ver=2.0",
        "Accept-Language": lang,
        authorization: "Bearer " + user.token,
      },
    }
  );

  return response.data?.returnData || [];
};

export { getHomeRouterOrders, placeHomeRouterOrder };
